<div>
    <div class="widget">
        <span class="withSpace">
            <button mat-raised-button color="primary" (click)="download()">Download this json</button>
        </span>
        <span class="withSpace">
            <button mat-raised-button color="primary" (click)="loadJson()">Load this json</button>
        </span>
    </div>

    <div class="withSpace">
        <textarea class="textAreaEditorComponent"
                [(ngModel)]="prettyJsonComponentSession"
                [rows]="getRows()"></textarea>
    </div>
</div>
